export default {"src":"/_next/static/media/circle-questionmark.1b3a9538.svg","height":16,"width":16,"blurWidth":0,"blurHeight":0};